import * as React from 'react';
import update from 'immutability-helper';
import {
  Button,
  Form,
  Grid,
  Input
  } from 'semantic-ui-react';
import { ConfirmationModal } from 'components/confirmation-modal/component';
import { CountryCode } from 'types/tenants/country-code';
import { getCountryName } from 'helpers/country-helpers';
import { getI18n } from 'services/i18n-service';
import { Guid } from 'types/guid';
import { hasPermissionTo } from 'helpers/permission-helper';
import { LanguageCode } from 'types/tenants/language-code';
import { Mode } from 'types/mode';
import { Permission } from 'types/permission';
import { translations } from 'types/translations';

import './styles.css';
import { Scrollable } from 'components/scrollable/component';

export interface ConnectedProps {
  isOnline: boolean | undefined;
  language: LanguageCode;
  permissions: string;
  countryCode: CountryCode;
  tenantId: Guid;
  deviceId: Guid;
}

export interface ActionProps {
  getDeviceInfo: () => void;
  unregisterDevice: () => void;
}

export type Props = ConnectedProps & ActionProps;

interface State {
  isUnregisterDeviceConfirmationOpen: boolean;
}

export class DeviceInfoPage extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      isUnregisterDeviceConfirmationOpen: false
    } as State;
  }

  componentWillMount() {
    this.props.getDeviceInfo();
  }

  openUnregisterDeviceConfirmation = () => {
    this.setState(update(this.state, {
      isUnregisterDeviceConfirmationOpen: { $set: true }
    }));
  }

  handleUnregisterDeviceConfirmed = () => {
    this.setState(update(this.state, {
      isUnregisterDeviceConfirmationOpen: { $set: false }
    }));
    this.props.unregisterDevice();
  }

  handleConfirmationClose = () => {
    this.setState(update(this.state, {
      isUnregisterDeviceConfirmationOpen: { $set: false }
    }));
  }

  public render() {
    const i18n = getI18n();
    const isAllowedUnregister = hasPermissionTo([Mode.Read], Permission.UnregisterDevice, this.props.permissions);

    return (
      <Scrollable>
        <Grid columns={1} padded="horizontally" className="form-page device-info-page">
          <Grid.Row>
            <Grid.Column width={16} className="padding-right">
              <Grid className="panel">
                <Grid.Row>
                  <Grid.Column computer={10} mobile={16}>
                    <Form>
                      <Form.Field className="location-identifier-field">
                        <label className="device-info-label">{i18n.t(translations.LocationIdentifier)}</label>
                        <Input className="device-info-input"
                          name="location-identifier"
                          value={this.props.tenantId}
                          disabled={true}
                        />
                      </Form.Field>
                      <Form.Field className="device-identifier-field">
                        <label className="device-info-label">{i18n.t(translations.DeviceId)}</label>
                        <Input className="device-info-input"
                          name="device-identifier"
                          value={this.props.deviceId}
                          disabled={true}
                        />
                      </Form.Field>
                      <Form.Field className="country-name-field">
                        <label className="device-info-label">{i18n.t(translations.Country)}</label>
                        <Input className="device-info-input"
                          name="country-name"
                          value={getCountryName(this.props.countryCode)}
                          disabled={true}
                        />
                      </Form.Field>
                      {
                        isAllowedUnregister
                        ? <Form.Field>
                            <div className="warning-message">
                              <p>
                                {i18n.t(translations.UnregisterDeviceWarning)}
                              </p>
                              <Button className="ui neutral button unregister-device-button"
                                color="red"
                                content={i18n.t(translations.UnregisterDevice)}
                                disabled={!this.props.isOnline}
                                onClick={this.openUnregisterDeviceConfirmation}/>
                            </div>
                          </Form.Field>
                        : null
                      }
                    </Form>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid >
        <ConfirmationModal
          isOpen={this.state.isUnregisterDeviceConfirmationOpen}
          object={this.props.deviceId}
          confirm={this.handleUnregisterDeviceConfirmed}
          close={this.handleConfirmationClose}
          title={i18n.t(translations.UnregisterDevice)}
          message={i18n.t(translations.ConfirmUnregisterDeviceMessage)}
        />
      </Scrollable>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/device-info/component.tsx